import React, { useCallback } from 'react';

interface StickyMessageProps {
  children: React.ReactNode;
}

const StickyMessage = function ({ children }: StickyMessageProps) {
  const currentNode = useCallback((node: HTMLDivElement) => {
    if (node) {
      node.scrollIntoView({ behavior: 'instant', block: 'start' });
    }
  }, []);

  return (
    <div ref={currentNode}>
      {children}
    </div>
  );
};

export default StickyMessage;
